import { useEffect } from 'react';
import { useQuery } from '@apollo/client/react';
import { useNavigate, useLocation } from 'react-router';

import Loading from 'components/Loading/Loading';
import { CUSTOMER_SEARCH } from 'queries/customerSearch';

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
};

const CustomerDirectLinkSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');

  const toCustomerSearch = () => {
    navigate('/customer-search');
  };

  const invalidEmail = !validateEmail(email);

  if (invalidEmail) {
    toCustomerSearch();
  }

  const customerSearchQuery = useQuery(CUSTOMER_SEARCH, {
    skip: invalidEmail,
    variables: {
      customerSearchRequestBody: { email: email },
    },
  });

  const { data, error } = customerSearchQuery;

  useEffect(() => {
    if (data) {
      const customer = data?.searchCustomer?.[0];
      if (customer?.customerType === 'CUSTOMER') {
        navigate(`/customers/${customer.customerId}`);
      } else if (customer?.customerType === 'APPLICANT') {
        navigate(`/applicants/${customer.customerId}`);
      } else {
        toCustomerSearch();
      }
    } else if (error) {
      toCustomerSearch();
    }
  }, [data, error]);

  return <Loading />;
};

export default CustomerDirectLinkSearch;
